import * as type from './types';
import { createReducer } from "../../util/index";

//Set the initial state for the current page , current limit and current search values
const initialState = {
    data: []
};

const agentInboxReducer = createReducer(initialState) ({
    //Export the response to the react.js to get the response data based on type name
    [type.GET_AGENT_INBOX]: (state, action) => ({
        ...state,
        agent_inbox_data: action.payload
    }),

    [type.SHOW_AGENT_INBOX]: (state, action) => ({
        ...state,
        show_agent_inbox: action.payload
    }),

    [type.CREATE_AGENT_INBOX]: (state, action) => ({
        ...state,
        create_agent_inbox: action.payload
    }),

    [type.DROPDOWN_AGENT_INBOX]: (state, action) => ({
        ...state,
        dropdown_agent_inbox: action.payload
    })
});

export default agentInboxReducer;